import { cn, formatPercentage } from "@/domains/library"

export const TextPercentage = ({
  value,
  decimals,
  className,
  definition,
}: {
  value: number
  decimals: number
  className?: string
  definition?: string
}) => {
  const safeValue = (value || 0) / 100
  const display = formatPercentage(safeValue, decimals)

  return <p className={cn(className)}>{display}</p>
}
